import { z } from 'zod';
import {
  CreateEmpresaRequestSchema,
  CreateEmpresaVisepRequestSchema,
  CreateLicenciaRequestSchema,
  EmpresaListQuerySchema,
  EmpresaSchema,
  EmpresaVisepListQuerySchema,
  EmpresaVisepSchema,
  LicenciaListQuerySchema,
  LicenciaSchema,
  UpdateEmpresaRequestSchema,
  UpdateLicenciaRequestSchema,
} from '@visep/shared-types/licencias';
import type { Helpers } from './internal.js';
import { makeCrudResource } from './internal.js';

export function createLicenciasResource({ request, requestMultipart }: Helpers) {
  const licencias = makeCrudResource(request, {
    basePath: '/api/licencias',
    schema: LicenciaSchema,
    listQuerySchema: LicenciaListQuerySchema,
    createSchema: CreateLicenciaRequestSchema,
    updateSchema: UpdateLicenciaRequestSchema,
  });
  const empresas = makeCrudResource(request, {
    basePath: '/api/empresas',
    schema: EmpresaSchema,
    listQuerySchema: EmpresaListQuerySchema,
    createSchema: CreateEmpresaRequestSchema,
    updateSchema: UpdateEmpresaRequestSchema,
  });
  const empresaViseps = makeCrudResource(request, {
    basePath: '/api/empresa-viseps',
    schema: EmpresaVisepSchema,
    listQuerySchema: EmpresaVisepListQuerySchema,
    createSchema: CreateEmpresaVisepRequestSchema,
    updateSchema: z.never(),
  });
  return {
    async uploadDocumento(id: string, file: Blob | File): Promise<{ archivoUrl: string | null }> {
      const form = new FormData();
      form.append('file', file, file instanceof File ? file.name : 'documento');
      return (await requestMultipart(`/api/licencias/${encodeURIComponent(id)}/documento`, form)) as {
        archivoUrl: string | null;
      };
    },
    listLicencias: licencias.list,
    getLicencia: licencias.get,
    createLicencia: licencias.create,
    updateLicencia: licencias.update,
    deleteLicencia: licencias.delete,
    listEmpresas: empresas.list,
    createEmpresa: empresas.create,
    updateEmpresa: empresas.update,
    deleteEmpresa: empresas.delete,
    listEmpresaViseps: empresaViseps.list,
    createEmpresaVisep: empresaViseps.create,
    deleteEmpresaVisep: empresaViseps.delete,
  };
}
